// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"581":"f85a47eb","699":"0f831d86"}[chunkId] + ".chunk.js";
};